import React, { useEffect, useState } from "react";
import ToggleSwitch from "../ToggleSwitch";
import { FiEdit } from "react-icons/fi";
import { RiDeleteBinLine } from "react-icons/ri";
import { useFnx } from "../../../store";
import { useUpdateFunctionality } from "../../../sevices/hooks/admin";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const SettingsData = ({
  description,
  subtext,
  showEdit,
  DeleteModal,
  setShowEdit,
  id,
  fnx,
  status,
  load,
  onToggleChange,
  toggleAll,
}: {
  description: any;
  subtext: any;
  showEdit?: boolean;
  DeleteModal: React.Dispatch<React.SetStateAction<boolean>>;
  setShowEdit: React.Dispatch<React.SetStateAction<boolean>>;
  id: string;
  fnx: any;
  status: boolean;
  load: boolean;
  onToggleChange?: (description: string, switchToggle: boolean) => void;
  toggleAll?: any;
}) => {
  const [switchToggle, setSwitchToggle] = useState(status);
  const { setFunctionalityId, setFunction, functionalityId } = useFnx();
  const [loading, setLoading] = useState(false);
  const updateFnx = useUpdateFunctionality(functionalityId);
  console.log(switchToggle, "switchToggle");
  console.log(status, "status");

  useEffect(() => {
    setSwitchToggle(status);
  }, [status]);
  console.log(showEdit, "uuuuu");
  const handleSubmit = (e: any) => {
    if (!showEdit) {
      onToggleChange && onToggleChange(description, !switchToggle);
      setSwitchToggle(!switchToggle);
      toggleAll && onToggleChange && onToggleChange(description, !toggleAll);
      toggleAll && setSwitchToggle(toggleAll);
    } else {
      setLoading(true);
      e.preventDefault();
      setFunctionalityId(id);
      const status = !switchToggle;

      setTimeout(() => {
        updateFnx
          .mutateAsync({
            status: status,
          })
          .then((res) => {
            setSwitchToggle(status);
            setLoading(false);
            console.log(res);
          })
          .catch((e) => {
            setLoading(false);
            toast.warn("An Error ocurred.. Please Retry");
          });
      }, 3000);
    }
  };

  return (
    <div className="flex justify-between border-b py-1">
      <div className="space-y-2">
        <div className="desc text-[#2B2B2B] text-base font-medium">
          {description}
        </div>
        <div className="subtext text-[#676767] text-xs  font-normal">
          {subtext}
        </div>
      </div>
      <div className="flex items-center gap-4 ">
        <ToggleSwitch
          value={switchToggle}
          onChange={(e) => handleSubmit(e)}
          label={""}
          isLoading={loading || load}
        />
        {/* )} */}
        {showEdit && (
          <div className="flex items-center gap-4">
            <div
              onClick={() => {
                setFunction(fnx);
                setFunctionalityId(id);
                setShowEdit(true);
              }}
              className=" cursor-pointer text-[#0eb683]"
            >
              <FiEdit size={20} />
            </div>
            <div
              onClick={() => {
                setFunctionalityId(id);
                DeleteModal(true);
              }}
              className=" cursor-pointer text-[#e60606]"
            >
              <RiDeleteBinLine size={20} />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default SettingsData;
